<!-- F1065-K2 P3S4 Component - Section 4 - Foreign Taxes -->
<!-- Migrated from AngularJS: ui/app/components/ftc/settings/F1065-k2/P3S4/FTC1065-P3-S4.html -->

<div class="f1065-k2-container">

  <!-- INITIAL LOADING STATE - shown when waiting for filter selection -->
  @if (loadingData) {
<div class="gg-loader">
    <div class="gg-loader-text">
      <img src="assets/img/arrow-filter-sm.png" alt="">
    </div>
  </div>
}

  <!-- MAIN CONTENT - shown after initialization -->
  @if (!loadingData) {
<div>
    
    <!-- FORM LOADER - shown while fetching data after filter selection -->
    @if (showLoader) {
<div class="form-loader">
      <div class="css-spinner"></div>
    </div>
}

    <!-- FORM CONTENT -->
    @if (!showLoader) {
<div>

      <!-- SECTION HEADER -->
      <p class="section-header h5">
        <b>{{ sectionHeader }}</b>
      </p>

      <!-- TABLE CONTAINER -->
      <div class="table-responsive">
        <table class="table table-striped k2-table">
          
          <!-- TABLE HEADER -->
          <thead>
            <tr align="center">
              <!-- Error Column -->
              @if (showErrCol) {
<th class="error-col">Error</th>
}
              
              <!-- Line Column -->
              <th class="line-col pl-2">Line</th>
              
              <!-- Description Column -->
              <th class="desc-col pl-2">Description</th>
              
              <!-- Dynamic Columns from Backend -->
              @for (col of colHeaderData | orderBy:'COL_PRIORITY'; track trackByCol($index, col)) {
<th
                  style="width: 120px; text-align: center; vertical-align: top;">
                {{ col.COL_DESC }}
                @if (col.IS_MANDATORY === 'Y') {
<span class="mandatory-marker">*</span>
}
                @if (col.IS_PREF_MANDATORY === 'Y') {
<span class="pref-mandatory-marker">+</span>
}
              </th>
}
            </tr>
          </thead>

          <!-- TABLE BODY -->
          <tbody>
            @for (line of groupedFormLines | filterBy:'IS_DISPLAY':'Y' | orderBy:['LINE_ORDER', 'SNO']; track trackByLine($index, line)) {
<tr>
              
              <!-- Error Column -->
              @if (showErrCol) {
<td class="error-col">
                <div [ngClass]="line.ERR_MSG && line.ERR_MSG.length > 0 ? 'err-cell-yes' : 'err-cell-no'"
                     [innerHTML]="line.ERR_MSG">
                </div>
              </td>
}

              <!-- Line Number Column -->
              <td class="line-cell">
                <!-- Add Row Icon -->
                @if (line.SNO === 0 && line.IS_LINE_MULTI === 'Y') {
<i
                   class="fa fa-plus-circle row-action-icon add-icon"
                   ap-tooltip [tooltipContent]="'Add Row'"
                   [direction]="'top'" [appendAfterTarget]="true"
                   (click)="addRow(line)"></i>
}
                
                <!-- Delete Row Icon -->
                @if (line.SNO > 0 && line.LINE_NO !== '1') {
<i
                   class="fa fa-minus-circle row-action-icon delete-icon"
                   ap-tooltip [tooltipContent]="'Delete Row'"
                   [direction]="'top'" [appendAfterTarget]="true"
                   (click)="deleteRow(line)"></i>
}
                
                <!-- Line Number -->
                @if (line.SNO === 0) {
<span>{{ line.LINE_NO }}</span>
}
              </td>

              <!-- Description Column -->
              <td class="desc-cell">
                <p style="width: 240px;">{{ line.SNO === 0 ? line.LINE_DESC : '' }}</p>
              </td>

              <!-- Value Columns -->
              @for (item of line.items | orderBy:'COL_ORDER'; track trackByItem($index, item)) {
<td 
                  class="value-cell">
                
                <!-- Hidden ADJ_KEY -->
                <input type="hidden" [value]="item.ADJ_KEY">

                <!-- NUMERIC Input -->
                @if (item.UI_COMP === 'NUMERIC') {
<input
                       type="text"
                       class="form-control min-ele-wid"
                       [ngClass]="{
                         'custom-error': item.IS_ERROR === 'Y',
                         'custom-textbox': item.IS_ENABLED === 'Y' || item.IS_ENABLED === 'Z'
                       }"
                       [(ngModel)]="item.CELL_VALUE"
                       [disabled]="item.IS_ENABLED === 'N'"
                       [readonly]="isLastNumericColumn(line.items, item)"
                       onlyIntegersWithLength
                       (ngModelChange)="onNumericChange(line.items)"
                       style="text-align: right;">
}

                <!-- TEXT Input -->
                @if (item.UI_COMP === 'TEXT') {
<input
                       type="text"
                       class="form-control min-ele-wid"
                       [ngClass]="{
                         'custom-error': item.IS_ERROR === 'Y',
                         'custom-textbox': item.IS_ENABLED === 'Y' || item.IS_ENABLED === 'Z'
                       }"
                       [(ngModel)]="item.CELL_VALUE"
                       [disabled]="item.IS_ENABLED === 'N'"
                       [maxlength]="item.MAX_LENGTH"
                       style="text-align: right;">
}

                <!-- CHECKBOX Input -->
                @if (item.UI_COMP === 'CHK_BX') {
<input
                       type="checkbox"
                       class="lg-chk"
                       [ngModel]="item.CELL_VALUE === 'X'"
                       (ngModelChange)="item.CELL_VALUE = $event ? 'X' : ''"
                       [disabled]="item.IS_ENABLED === 'N'">
}

                <!-- DATE Input (Enabled) -->
                @if (item.UI_COMP === 'DATE' && item.IS_ENABLED !== 'N') {
<div 
                     class="date-input-group">
                  <input type="date"
                         class="form-control min-ele-wid"
                         [ngClass]="{
                           'custom-error': item.IS_ERROR === 'Y',
                           'custom-textbox': item.IS_ENABLED === 'Y' || item.IS_ENABLED === 'Z'
                         }"
                         [ngModel]="item.CELL_VALUE | date:'yyyy-MM-dd'"
                         (ngModelChange)="onDateChange(item, $event)"
                         placeholder="yyyy-mm-dd"
                         style="font-size: 11px;">
                </div>
}

                <!-- DATE Input (Disabled) -->
                @if (item.UI_COMP === 'DATE' && item.IS_ENABLED === 'N') {
<div 
                     class="date-input-group">
                  <input type="date"
                         class="form-control min-ele-wid"
                         [ngClass]="{
                           'custom-error': item.IS_ERROR === 'Y'
                         }"
                         [ngModel]="item.CELL_VALUE | date:'yyyy-MM-dd'"
                         disabled
                         readonly
                         placeholder="yyyy-mm-dd"
                         style="font-size: 11px;">
                </div>
}

                <!-- DROPDOWN Select -->
                @if (item.UI_COMP === 'DROP_DOWN') {
<select
                        class="form-control min-ele-wid k2-select"
                        [ngClass]="{
                          'custom-error': item.IS_ERROR === 'Y',
                          'custom-textbox': item.IS_ENABLED === 'Y' || item.IS_ENABLED === 'Z'
                        }"
                        [(ngModel)]="item.CELL_VALUE"
                        [disabled]="item.IS_ENABLED === 'N'">
                  <option value="">--Select--</option>
                  @for (opt of item.actionData; track $index) {
<option [value]="opt.VALUE">
                    {{ opt.LABEL }}
                  </option>
}
                </select>
}

              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>

      <!-- BUTTONS -->
      <div class="k2-buttons-container">
        <button class="save-button"
                type="button"
                [disabled]="!isAdmin || isSaveClicked"
                (click)="save()">
          @if (isSaveClicked) {
<span><i class="fa fa-spinner fa-pulse"></i> </span>
}
          Save
        </button>
        <button class="reset-button"
                type="button"
                [disabled]="!isAdmin"
                (click)="reset()">
          Reset
        </button>
      </div>

    </div>
}
  </div>
}
</div>

<!-- CONFIRMATION MODAL OVERLAY -->
@if (showConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onSaveConfirm()"
    (cancelled)="onSaveCancel()"
    (closed)="onSaveCancel()">
  </gtw-confirmation-modal>
</div>
}
